"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.close = exports.start = void 0;
var nprogress_1 = __importDefault(require("nprogress"));
require("nprogress/nprogress.css");
nprogress_1.default.configure({
// easing: 'ease', // 动画方式
// speed: 1000, // 递增进度条的速度
// showSpinner: false, // 是否显示加载ico
// trickleSpeed: 200, // 自动递增间隔
// minimum: 0.3, // 更改启动时使用的最小百分比
// parent: 'body', //指定进度条的父容器
});
// 开启进度条
var start = function () {
    nprogress_1.default.start();
};
exports.start = start;
// 关闭进度条
var close = function () {
    nprogress_1.default.done();
};
exports.close = close;
